import React, { useState, useContext, useEffect, useRef } from "react";
// import Cookies from "js-cookie";
import {
  Button,
  Typography,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import ReactQuill from "react-quill";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { errorDialogOpen } from "../../redux/dialogs/dialogActions";
import {
  ArrowForward,
  DeleteForever,
  DeleteOutlineOutlined,
  CancelOutlined,
  Close,
} from "@mui/icons-material";
import { AddApplicationContext } from "../../context/AddApplicationContext";
import TestComponent from "../../components/TestComponent";
import ErrorModal from "../../components/ErrorModal";
import ErrorText from "../../components/ErrorText";
import { basePath } from "../../utility";
import ProcessProgress from "../../components/ProcessProgress";
import LoaderModal from "../../components/LoaderModal";
import useFetch from "../../hooks/useFetch";

export default function Contacts() {
  const [maritalStatus, setMaritalStatus] = useState("");
  const [fatherStatus, setFatherStatus] = useState("");
  const [motherStatus, setMotherStatus] = useState("");
  // const [openCategories, setOpenCategories] = useState(false);
  // const [contributorType, setContributorType] = useState("author");
  // const [contributorFirstName, setContributorFirstName] = useState("");
  // const [contributorLastName, setContributorLastName] = useState("");
  // const [publisherName, setPublisherName] = useState("");

  // const [nationalityList, setNationalityList] = useState(null);
  // const [ethnicityList, setEthnicityList] = useState(null);
  // const [religionList, setReligionList] = useState(null);
  // const [programList, setProgramList] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState(null);
  const [onSuccessButtonLable, setOnSuccessButtonLable] = useState(null);

  const [onErrorButtonLable, setOnErrorButtonLable] = useState(null);
  const url = basePath.url;

  const {
    currentStep,
    setStep,
    applicationId,
    setApplicationId,
    stepDetails,
    setStepDetails,
    stepsCompleteStatus,
    setStepsCompletedStatus,
  } = useContext(AddApplicationContext);
  const logger = useSelector((state) => {
    return state.logger;
  });

  useEffect(() => {
    console.log(stepDetails.contactDetails && stepDetails.contactDetails);
  });
  const initialValues = {
    addressBox:
      stepDetails.contactDetails && stepDetails.contactDetails.addressBox
        ? stepDetails.contactDetails.addressBox
        : "",
    addressCode:
      stepDetails.contactDetails && stepDetails.contactDetails.addressCode
        ? stepDetails.contactDetails.addressCode
        : "",
    addressTown:
      stepDetails.contactDetails && stepDetails.contactDetails.addressTown
        ? stepDetails.contactDetails.addressTown
        : "",
    nextOfKinName:
      stepDetails.contactDetails && stepDetails.contactDetails.nextOfKinName
        ? stepDetails.contactDetails.nextOfKinName
        : "",
    nextOfKinRelationship:
      stepDetails.contactDetails &&
      stepDetails.contactDetails.nextOfKinRelationship
        ? stepDetails.contactDetails.nextOfKinRelationship
        : "",
    nextOfKinPhoneNumber:
      stepDetails.contactDetails &&
      stepDetails.contactDetails.nextOfKinPhoneNumber
        ? stepDetails.contactDetails.nextOfKinPhoneNumber
        : "",
    maritalStatus:
      stepDetails.contactDetails && stepDetails.contactDetails.maritalStatus
        ? stepDetails.contactDetails.maritalStatus
        : "",
    spouseName:
      stepDetails.contactDetails && stepDetails.contactDetails.spouseName
        ? stepDetails.contactDetails.spouseName
        : "",
    spousePhoneNumber:
      stepDetails.programDetails && stepDetails.programDetails.spousePhoneNumber
        ? stepDetails.programDetails.spousePhoneNumber
        : "",
    fatherStatus:
      stepDetails.programDetails && stepDetails.programDetails.fatherStatus
        ? stepDetails.programDetails.fatherStatus
        : "",

    fatherFullName:
      stepDetails.programDetails && stepDetails.programDetails.fatherFullName
        ? stepDetails.programDetails.fatherFullName
        : "",
    fatherPhoneNumber:
      stepDetails.programDetails && stepDetails.programDetails.fatherPhoneNumber
        ? stepDetails.programDetails.fatherPhoneNumber
        : "",

    motherStatus:
      stepDetails.programDetails && stepDetails.programDetails.motherStatus
        ? stepDetails.programDetails.motherStatus
        : "",
    motherFullName:
      stepDetails.programDetails && stepDetails.programDetails.motherFullName
        ? stepDetails.programDetails.motherFullName
        : "",
    motherPhoneNumber:
      stepDetails.programDetails && stepDetails.programDetails.motherPhoneNumber
        ? stepDetails.programDetails.motherPhoneNumber
        : "",

    guardianName:
      stepDetails.programDetails && stepDetails.programDetails.guardianName
        ? stepDetails.programDetails.guardianName
        : "",
    guardianPhoneNumber:
      stepDetails.programDetails &&
      stepDetails.programDetails.guardianPhoneNumber
        ? stepDetails.programDetails.guardianPhoneNumber
        : "",
    guardianEmail:
      stepDetails.programDetails && stepDetails.programDetails.guardianEmail
        ? stepDetails.programDetails.guardianEmail
        : "",
  };

  const validationSchema = Yup.object({
    addressBox: Yup.string().required("Address Box is required"),
    addressCode: Yup.string().required("Address Code is required"),
    addressTown: Yup.string().required("Address Town is required"),

    nextOfKinName: Yup.string().required("Next Of Kin Name  is required"),
    nextOfKinRelationship: Yup.string().required(
      "Next Of Kin Relationship  is required"
    ),
    nextOfKinPhoneNumber: Yup.string().required(
      "Next Of KinPhoneNumber  is required"
    ),

    maritalStatus: Yup.string().required("Please Select Marital Status "),
    spouseName: Yup.string().when("maritalStatus", {
      is: (val) => val == "married",
      then: () => Yup.string().required("Spouse Full Name  is required"),
    }),
    spousePhoneNumber: Yup.string().when("maritalStatus", {
      is: (val) => val == "married",
      then: () => Yup.string().required("Spouse Phone Number  is required"),
    }),

    fatherStatus: Yup.string().required("Please Select Father's Status "),
    fatherFullName: Yup.string().when("fatherStatus", {
      is: (val) => val == "alive",
      then: () => Yup.string().required("Father Full Name  is required"),
    }),
    fatherPhoneNumber: Yup.string().when("fatherStatus", {
      is: (val) => val == "alive",
      then: () => Yup.string().required("Father Phone Number  is required"),
    }),

    motherStatus: Yup.string().required("Please Select Mother's Status "),
    motherFullName: Yup.string().when("motherStatus", {
      is: (val) => val == "alive",
      then: () => Yup.string().required("Mother Full Name  is required"),
    }),
    motherPhoneNumber: Yup.string().when("motherStatus", {
      is: (val) => val == "alive",
      then: () => Yup.string().required("Mother Phone Number  is required"),
    }),
  });

  const onSuccessCallback = () => {
    setOpenLoader(false);
    setStep((val) => {
      return val + 1;
    });
  };

  const onErrorCallback = () => {
    setOpenLoader(false);
  };

  const onSubmitContactDetails = async (values, onSubmitProps) => {
    setError(null);
    setLoading(true);
    setFeedback(null);
    setOpenLoader(true);
    setLoaderMessage("Adding Contact Details");

    values.type = "add";
    values.user_id = logger.user.userId;
    values.applicationId = stepDetails.programDetails?.applicationId;

    console.log(values);

    try {
      const addProgram = await axios.post(
        `${url}application/add-contacts`,
        values
      );
      // console.log(addProgram);
      if (addProgram.data.message === "error") {
        let err_data = addProgram.data.data;
        setError(
          // err_data === "duplicate"
          //   ? "Book with the same  number  exists"
          //   : addProgram.data.data
          "Error Adding Contact Details"
        );
        setLoading(false);
        setFeedback(null);
        onSubmitProps.setSubmitting(false);
        // onSubmitProps.resetForm();
      } else {
        if (!addProgram.data.data) {
          setError(true);
          setOnErrorButtonLable("Ok");
          values.type === "add"
            ? setLoaderMessage("Error Adding Contact Details! Please try again")
            : setLoaderMessage(
                "Error Updating Contact Details! Please try again"
              );
          setLoading(false);
        } else {
          const stepData = { ...stepDetails };
          values.id = addProgram.data.data;
          stepData.contactDetails = values;
          setStepDetails(stepData);
          setError(null);
          setLoading(false);
          setFeedback("Contact Details Added Successfully");
          onSubmitProps.setSubmitting(false);
          onSubmitProps.resetForm();
          setOnSuccessButtonLable("Ok");
          // setStep1Completed(true);
          values.type === "add"
            ? setLoaderMessage("Contact Details added successfully")
            : setLoaderMessage("Contact Details updated successfully");
          setLoading(false);
          setError(null);
        }
      }
    } catch (error) {
      setLoaderMessage(`Error Adding Contact Details ${error.message}`);
      setError("Error Adding Application Contact Details");
      setOnErrorButtonLable("Ok");
      // addProgram.data.action === "add"
      //   ? setLoaderMessage("Error Adding Program Details! Please try again")
      //   : setLoaderMessage("Error Updating Program Details! Please try again");
      setLoading(false);
      setFeedback(null);
      onSubmitProps.setSubmitting(false);
      //onSubmitProps.resetForm();
    }
  };

  const dispatch = useDispatch();
  const errDialog = useSelector((state) => {
    return state.dialogReducer;
  });

  const courses = useSelector((state) => {
    return state.coursesReducer.courses;
  });

  const semPeriods = useSelector((state) => {
    return state.semPeriodReducer.semPeriods;
  });

  return (
    <>
      <ErrorModal />
      <LoaderModal
        loaderMessage={loaderMessage}
        openLoader={openLoader}
        setOpenLoader={setOpenLoader}
        loading={loading}
        error={error}
        onSuccessButtonLable={onSuccessButtonLable}
        onSuccessCallback={onSuccessCallback}
        onErrorButtonLable={onErrorButtonLable}
        onErrorCallback={onErrorCallback}
      />

      <div className="addBookWrapper" style={{ height: "100%" }}>
        <Formik
          // enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={onSubmitContactDetails}
          validationSchema={validationSchema}
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            isValid,
            isSubmitting,
            setFieldValue,
            setValues,
          }) => (
            <Form>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Home Address</span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Address Box (P.O BOX):</label>
                      <Field
                        type="text"
                        name="addressBox"
                        id="addressBox"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage name="addressBox" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Address Code:</label>
                      <Field
                        type="text"
                        name="addressCode"
                        id="addressCode"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage name="addressCode" component={ErrorText} />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Address Town:</label>
                      <Field
                        type="text"
                        name="addressTown"
                        id="addressTown"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage name="addressTown" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Next of Kin Details</span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Next Of Kin Name:</label>
                      <Field
                        type="text"
                        name="nextOfKinName"
                        id="nextOfKinName"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage
                        name="nextOfKinName"
                        component={ErrorText}
                      />
                    </div>

                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Next Of Kin Relationship </label>
                      <Field
                        as="select"
                        name="nextOfKinRelationship"
                        id="nextOfKinRelationship"
                        // style={{ width: "90%" }}
                      >
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value=""
                        >
                          --Select--
                        </option>
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value="father"
                        >
                          Father
                        </option>
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value="mother"
                        >
                          mother
                        </option>
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value="spouse"
                        >
                          Spouse
                        </option>
                        <option
                          style={{ fontSize: 12, fontFamily: "sans-serif" }}
                          value="child"
                        >
                          child
                        </option>
                      </Field>
                      <ErrorMessage
                        name="nextOfKinRelationship"
                        component={ErrorText}
                      />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Next Of Kin Phone Number:</label>
                      <Field
                        type="text"
                        name="nextOfKinPhoneNumber"
                        id="nextOfKinPhoneNumber"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage
                        name="nextOfKinPhoneNumber"
                        component={ErrorText}
                      />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Marital Details</span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="formControl" style={{ width: 200 }}>
                      <label>Marital Status:</label>
                      <select
                        name="maritalStatus"
                        id="nextOfKinName"
                        value={maritalStatus}
                        onChange={(e) => {
                          setMaritalStatus(e.target.value);
                          setFieldValue("maritalStatus", e.target.value);
                        }}
                        style={{ width: 200 }}
                      >
                        <option value="">--select--</option>
                        <option value="single">Single</option>
                        <option value="married">Married</option>
                      </select>

                      <ErrorMessage
                        name="maritalStatus"
                        component={ErrorText}
                      />
                    </div>
                    {maritalStatus.toLocaleLowerCase() == "married" && (
                      <>
                        <div
                          className="formControl"
                          style={{
                            flex: 1,
                          }}
                        >
                          <label>Full Name of Spouse</label>
                          <Field
                            type="text"
                            name="spouseName"
                            id="spouseName"
                            // style={{ width: "90%" }}
                          />

                          <ErrorMessage
                            name="spouseName"
                            component={ErrorText}
                          />
                        </div>
                        <div
                          className="formControl"
                          style={{
                            flex: 1,
                          }}
                        >
                          <label>Spouse Phone Number:</label>
                          <Field
                            type="text"
                            name="spousePhoneNumber"
                            id="spousePhoneNumber"
                            // style={{ width: "90%" }}
                          />

                          <ErrorMessage
                            name="spousePhoneNumber"
                            component={ErrorText}
                          />
                        </div>
                      </>
                    )}
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Parent Details</span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="formControl" style={{ width: 200 }}>
                      <label>Father Status:</label>
                      <Field as="select" name="fatherStatus" id="fatherStatus">
                        <option value="">--select--</option>
                        <option value="alive">Alive</option>
                        <option value="deceased">deceased</option>
                        <option value="Not Applicable">Not Applicable</option>
                      </Field>

                      <ErrorMessage name="fatherStatus" component={ErrorText} />
                    </div>
                    {values.fatherStatus.toLowerCase() == "alive" && (
                      <>
                        <div
                          className="formControl"
                          style={{
                            flex: 1,
                          }}
                        >
                          <label> Full Name of Father</label>
                          <Field
                            type="text"
                            name="fatherFullName"
                            id="fatherFullName"
                            // style={{ width: "90%" }}
                          />

                          <ErrorMessage
                            name="fatherFullName"
                            component={ErrorText}
                          />
                        </div>
                        <div
                          className="formControl"
                          style={{
                            flex: 1,
                          }}
                        >
                          <label>Father Phone Number:</label>
                          <Field
                            type="text"
                            name="fatherPhoneNumber"
                            id="fatherPhoneNumber"
                            // style={{ width: "90%" }}
                          />

                          <ErrorMessage
                            name="fatherPhoneNumber"
                            component={ErrorText}
                          />
                        </div>
                      </>
                    )}
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div className="formControl" style={{ width: 200 }}>
                      <label>Mother Status:</label>
                      <select
                        name="motherStatus"
                        id="motherStatus"
                        value={motherStatus}
                        onChange={(e) => {
                          setMotherStatus(e.target.value);
                          setFieldValue("motherStatus", e.target.value);
                        }}
                        style={{ width: 200 }}
                      >
                        <option value="">--select--</option>
                        <option value="alive">Alive</option>
                        <option value="deceased">deceased</option>
                        <option value="not applicable">Not Applicable</option>
                      </select>

                      <ErrorMessage name="motherStatus" component={ErrorText} />
                    </div>
                    {motherStatus.toLowerCase() == "alive" && (
                      <>
                        <div
                          className="formControl"
                          style={{
                            flex: 1,
                          }}
                        >
                          <label> Full Name of Mother</label>
                          <Field
                            type="text"
                            name="motherFullName"
                            id="motherFullName"
                            // style={{ width: "90%" }}
                          />

                          <ErrorMessage
                            name="motherFullName"
                            component={ErrorText}
                          />
                        </div>
                        <div
                          className="formControl"
                          style={{
                            flex: 1,
                          }}
                        >
                          <label>Mother Phone Number:</label>
                          <Field
                            type="text"
                            name="motherPhoneNumber"
                            id="motherPhoneNumber"
                            // style={{ width: "90%" }}
                          />

                          <ErrorMessage
                            name="motherPhoneNumber"
                            component={ErrorText}
                          />
                        </div>
                      </>
                    )}
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="addBookContainer">
                <div className="addBookCaption">
                  <Typography variant="subtitle2">
                    <span className="header2">Guardian Details</span>&nbsp;
                    <span
                      style={{ fontSize: 11, fontWeight: 500, color: "#444" }}
                    >
                      (optional)
                    </span>
                  </Typography>
                </div>
                <div className="addBookDetails">
                  <div
                    className="fullWidthWrapper"
                    style={{
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Guardian Name </label>
                      <Field
                        type="text"
                        name="guardianName"
                        id="guardianName"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage name="guardianName" component={ErrorText} />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Guardian Phone Number:</label>
                      <Field
                        type="text"
                        name="guardianPhoneNumber"
                        id="guardianPhoneNumber"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage
                        name="guardianPhoneNumber"
                        component={ErrorText}
                      />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    >
                      <label>Guardian Email:</label>
                      <Field
                        type="text"
                        name="guardianEmail"
                        id="guardianEmail"
                        // style={{ width: "90%" }}
                      />

                      <ErrorMessage
                        name="guardianEmail"
                        component={ErrorText}
                      />
                    </div>
                    <div
                      className="formControl"
                      style={{
                        flex: 1,
                      }}
                    ></div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: 10,
                  marginLeft: 0,
                  paddingTop: 10,
                  marginRight: 0,
                }}
              >
                <button
                  type="submit"
                  className="btn-secondary"
                  onClick={() => {
                    setStep((val) => {
                      return val - 1;
                    });
                  }}
                >
                  &lt; Back to Education Details
                </button>
                <button
                  type="submit"
                  className="btn-primary"
                  // onClick={() => {
                  //   setStep((val) => {
                  //     return val + 1;
                  //   });
                  // }}
                  disabled={
                    (!isValid || isSubmitting) && !stepDetails.contactDetails
                  }
                >
                  Save and Continue
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
